<div class="h-full" *transloco="let t">
  <div class="flex h-full">
    <div class="h-full" style="width: 35rem">
      <app-tracked-asin-selection
        [marketplace]="(selectedAccountMarketplace$ | async)?.marketplace"
        (hover)="onAsinSelectorHover($event)"
        (leave)="onAsinSelectorLeave()"
        [datavizScroll]="datavizScroll"
        [updateScrollEvent]="updateScroll.asObservable()"
      ></app-tracked-asin-selection>
    </div>
    <div class="dataviz-wrapper ml-3 flex flex-col overflow-auto p-3">
      <div class="dataviz-header">
        <div class="flex items-center justify-between">
          <div class="flex">
            <ISwitchButton
              class="rank-switch ml-3"
              [options]="[true, false]"
              [buttonTexts]="['common.table', 'common.chart']"
              [buttonTooltips]="['', '']"
              [selected]="tableView()"
              (buttonClicked)="setTableView($event)"
            ></ISwitchButton>
          </div>

          <div class="flex">
            <ISwitchButton
              class="rank-switch ml-3"
              [options]="RANK_OPTIONS_ARRAY"
              [buttonTexts]="RANK_OPTIONS_ARRAY"
              [buttonTooltips]="RANK_OPTIONS_DESC"
              [selected]="rankOption()"
              (buttonClicked)="selectRankOption($event)"
            ></ISwitchButton>

            @if (!tableView() && (dateAggregation$ | async)) {
              <IDateAggreationSwitchButton
                class="aggregation-switch ml-3"
                [options]="dateAggregations"
                [selected]="(dateAggregation$ | async)!"
                (dateAggSelected)="selectDateAggregation($event)"
              ></IDateAggreationSwitchButton>
            }

            @if (tableView()) {
              <app-export-button class="ml-3" (export)="exportData()" />
            }
          </div>
        </div>

        @if (rankOption() === RankOption.BOTH) {
          <div class="both-opt-legend mt-2 ml-4 flex items-center">
            <div class="org"></div>
            <div class="mr-3">{{ t("common.organic") }}</div>
            <div class="sp"></div>
            {{ t("common.sponsored") }}
          </div>
        }
      </div>
      <div class="dataviz-content mt-2 w-full overflow-auto" #datavizScroll (scroll)="updateScroll.next($event)">
        @if (tableView()) {
          <app-keyword-tracking-timeline-table
            [accountMarketplace]="(selectedAccountMarketplace$ | async)!"
            [rankOption]="rankOption()!"
          ></app-keyword-tracking-timeline-table>
        } @else {
          <IChart [config]="datasetConfig()" [data]="data()" [hoverItem]="hoveredAsin()" />
        }
      </div>
    </div>
  </div>
</div>
